/* global Waypoint */
import 'waypoints/lib/noframework.waypoints';

const newsletter = (el) => {
    new Waypoint({
        element: el,
        offset: 400,
        handler: (direction) => waypointHandler(el, direction),
    });
};

const waypointHandler = (el, direction) => {
    if(direction === 'down') {
        el.classList.add('js-state-newsletter--animate');
    }
};

export default newsletter;